import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ProductSetDetails } from "../../productsSets.types";
import { requestProductSetDetails } from "./productSetDetails.request";

const useProductSetDetails = (
  setId: string | null,
  options?: QueryOptions<ProductSetDetails, ApiServiceError<ApiError>>
) => {
  const { data, isLoading, ...rest } = useQuery({
    queryKey: ["product-sets", "details", setId],
    queryFn: async () => await requestProductSetDetails(setId ?? ""),
    enabled: !!setId,
    cacheTime: 0,
    ...options
  });

  return {
    productSetDetails: data,
    isProductSetDetailsLoading: isLoading,
    ...rest
  };
};

export default useProductSetDetails;
